import { gql } from "graphql-request";

import { BillingPeriod } from "apps-common/types";
import { axiosQuery } from "apps-common/utils/axiosHelpers";
import { logger } from "apps-common/utils/logger";

interface RenewSubscriptionResponse {
  renewSubscription: string;
}

const RENEW_SUBSCRIPTION_MUTATION = gql`
  mutation RenewSubscription($billingPeriod: ApiBillingPeriod!) {
    renewSubscription(billingPeriod: $billingPeriod)
  }
`;

export const renewSubscription = async (billingPeriod: BillingPeriod) =>
  axiosQuery<RenewSubscriptionResponse>(
    "RenewSubscription",
    RENEW_SUBSCRIPTION_MUTATION,
    { billingPeriod },
  ).catch((error) => {
    logger.error(`Error occurred while renewing`, { error });
    throw error;
  });
